module.exports = __webpack_public_path__ + "img/symmetry_cn.2e4f9c6.jpg";